import(/* webpackMode: "eager", webpackExports: ["CaseStudyNav","CaseStudyLayout"] */ "/opt/build/repo/src/app/portfolio/[id]/components.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DescriptionCard"] */ "/opt/build/repo/src/components/DescriptionCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Shimmer"] */ "/opt/build/repo/src/components/ui/shimmer.tsx");
